// src/App.js - Modern SaaS Layout with Sidebar + Dual Authentication
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/theme.css';
import './styles/components.css';
import LoginPage from './components/LoginPage';
// Removed old auth imports
import Dashboard from './components/Dashboard';
import UserProfile from './components/UserProfile'
import EditOrder from './components/EditOrder';
import SaleCoResponse from './components/SaleCoResponse';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import ManualSOProcessor from './components/ManualSOProcessor';
import Help from './components/Help';
import RentalSO from './components/RentalSO';
import WebhookLog from './components/WebhookLog';
import RentalAssets from './components/RentalAssets';
import UatRental from './components/UatRental';
import UatWorkspace from './components/UatWorkspace';
import RentalOrderForm from './components/RentalOrderForm';
import RequestMachine from './pages/fifo/RequestMachine';
import AllRequests from './pages/fifo/AllRequests';
import RequestDetail from './pages/fifo/RequestDetail';
import EditRequest from './pages/fifo/EditRequest';
import InventoryQueue from './pages/fifo/InventoryQueue';
import QcQueue from './pages/fifo/QcQueue';
import QcRequestDetail from './pages/fifo/QcRequestDetail';
import QcHistory from './pages/fifo/QcHistory';
import { AuthProvider, PrivateRoute } from './context/AuthContext';
import './App.css';
import './styles/saas.css';

const AUTH_ROUTES = ['/login'];

function AppLayout() {
  const location = useLocation();
  const isAuthPage = AUTH_ROUTES.some(path => location.pathname.startsWith(path));

  return (
    <div className={isAuthPage ? '' : 'app-layout'}>
      {!isAuthPage && <Sidebar />}
      {!isAuthPage && <Header />}
      <main className={isAuthPage ? '' : 'app-main'}>
        <Routes>
          {/* Public Auth Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Private Routes */}
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/order/:id" element={
            <PrivateRoute>
              <EditOrder />
            </PrivateRoute>
          } />
          <Route path="/response/:id" element={
            <PrivateRoute>
              <SaleCoResponse />
            </PrivateRoute>
          } />
          <Route path="/profile" element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          } />
          <Route path="/manual-processor" element={
            <PrivateRoute>
              <ManualSOProcessor />
            </PrivateRoute>
          } />
          <Route path="/help" element={
            <PrivateRoute>
              <Help />
            </PrivateRoute>
          } />
          <Route path="/uat/rental/:id" element={
            <PrivateRoute>
              <UatWorkspace />
            </PrivateRoute>
          } />
          <Route path="/uat/rental" element={
            <PrivateRoute>
              <UatRental />
            </PrivateRoute>
          } />
          <Route path="/webhook-log" element={
            <PrivateRoute>
              <WebhookLog />
            </PrivateRoute>
          } />
          <Route path="/ememo-settings" element={<Navigate to="/profile" replace />} />
          <Route path="/rental-assets" element={
            <PrivateRoute>
              <RentalAssets />
            </PrivateRoute>
          } />
          <Route path="/rental-so" element={
            <PrivateRoute>
              <RentalSO />
            </PrivateRoute>
          } />
          <Route path="/rental-so/:id" element={
            <PrivateRoute>
              <RentalOrderForm />
            </PrivateRoute>
          } />

          {/* FIFO Workflow Routes */}
          <Route path="/request-machine" element={
            <PrivateRoute>
              <RequestMachine />
            </PrivateRoute>
          } />
          <Route path="/all-requests" element={
            <PrivateRoute>
              <AllRequests />
            </PrivateRoute>
          } />
          <Route path="/request-detail/:id" element={
            <PrivateRoute>
              <RequestDetail />
            </PrivateRoute>
          } />
          <Route path="/edit-request/:document_id" element={
            <PrivateRoute>
              <EditRequest />
            </PrivateRoute>
          } />
          <Route path="/inventory-queue" element={
            <PrivateRoute allowedRoles={['warehouse']}>
              <InventoryQueue />
            </PrivateRoute>
          } />
          <Route path="/qc-queue" element={
            <PrivateRoute allowedRoles={['qc']}>
              <QcQueue />
            </PrivateRoute>
          } />
          <Route path="/qc-queue/:document_id" element={
            <PrivateRoute allowedRoles={['qc']}>
              <QcRequestDetail />
            </PrivateRoute>
          } />
          <Route path="/qc-history" element={
            <PrivateRoute allowedRoles={['qc']}>
              <QcHistory />
            </PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout />
      </Router>
    </AuthProvider>
  );
}

export default App;